module.exports = __webpack_public_path__ + "img/20200808_150054.ad1dcd39.jpg";